'use client'

import { HugeiconsIcon } from '@hugeicons/react'
import { MagicWand01Icon } from '@hugeicons-pro/core-stroke-rounded'
import { Button } from '@/components/ui/button'
import { useChat } from '@/contexts/ChatContext'

type CopilotFooterButtonProps = {
  hasContent: boolean
}

export function CopilotFooterButton({ hasContent }: CopilotFooterButtonProps) {
  const { openChat, pendingCommandFormContext, setPendingCommandFormContext } = useChat()

  return (
    <Button
      type="button"
      variant="outline"
      className="gap-1.5"
      onClick={() => {
        if (pendingCommandFormContext) {
          setPendingCommandFormContext({ ...pendingCommandFormContext, focusedField: undefined })
        }
        openChat(null, {
          seedMessage: hasContent
            ? 'Looking at your current command, what would you like help with?'
            : 'What should this command do?',
        })
      }}
    >
      <HugeiconsIcon icon={MagicWand01Icon} className="size-4" />
      Ask AI
    </Button>
  )
}
